/**
 * Assembly manual difficulty calculation utilities
 */

export interface DifficultyResult {
  numeric: number;
  label: string;
}

/**
 * Maps numeric difficulty value to label
 */
export const getDifficultyLabel = (difficulty: number): string => {
  if (difficulty <= 1) return 'Very easy';
  if (difficulty <= 2) return 'Easy';
  if (difficulty <= 3) return 'Moderate';
  if (difficulty <= 4) return 'Difficult';
  return 'Very difficult';
};

/**
 * Calculates average difficulty from an array of difficulty strings
 */
export const calculateAverageDifficulty = (difficultyArray: string[]): DifficultyResult => {
  // Map difficulty levels to numeric values
  const difficultyMap: Record<string, number> = {
    'Very easy': 1,
    Easy: 2,
    Moderate: 3,
    Difficult: 4,
    'Very difficult': 5,
  };

  // Convert difficulty strings to numbers
  const numericValues = difficultyArray
    .map(difficulty => difficultyMap[difficulty])
    .filter(value => value !== undefined); // Remove any invalid difficulties

  // Calculate average
  if (numericValues.length === 0) {
    return {
      numeric: 0,
      label: 'Unknown',
    };
  }

  const sum = numericValues.reduce((acc, curr) => acc + curr, 0);
  const average = sum / numericValues.length;

  const label = getDifficultyLabel(average);

  return {
    numeric: average,
    label,
  };
};
